import moment from 'moment'
import { defineStore } from 'pinia'

const initialState = () => ({
    formData: {
        part: '',
        sa_id: '',
        customer: '',
        customer_ref: '',
        date_range: 'today',
        range: [moment().toDate(), moment().toDate()],
        my_quotes: true,
        all_quotes: true,
        standard_quotes: true,
        unassigned: false,
    },
})

export const useQuoteFormStore = defineStore('quoteForm', {
    state: () => initialState(),
    actions: {
        setFormData(formData) {
            this.formData = formData
        },
        resetFormData() {
            this.formData = initialState().formData
        },
    },
})
